<template>
  <modal
    title="Domains"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div class="py-6">
      <div>
        <label class="label">Name</label>
        <base-input
          v-model="payload.subDomain.name"
          placeholder="Enter Domain Name"
        />
      </div>
      <div>
        <label class="label">Email</label>
        <base-input v-model="payload.subDomain.email" placeholder="Enter Email" />
      </div>
      <div>
        <label class="label">Password</label>
        <base-input
          v-model="payload.subDomain.password"
          placeholder="Enter Password"
        />
      </div>
    </div>
    <hr class="mt-2 mb-6" />
    <div class="flex justify-between">
      <p class="text-darkBlue cursor-pointer font-semibold" @click="closeModal">
        Cancel
      </p>
      <base-button
        :text="`${selectedsubDomainDetails ? 'Update' : 'Save'}`"
        :loading="loading"
        @click="submit"
      />
    </div>
  </modal>
</template>

<script>

export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    selectedsubDomainDetails: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      payload:{
        subDomain: {
          name: "",
          email: "",
          password: "",
        }
      }
    };
  },
  watch: {
    selectedsubDomainDetails() {
      this.subDomain = {
        ...this.selectedsubDomainDetails
      };
    },
  },
  methods: {
    submit() {
      if (this.selectedsubDomainDetails) {
        this.updateDomain();
      } else {
        this.createDomain();
      }
    },
    async createDomain() {
      this.loading = true;
      try {
        const response = await this.$_createDomain(this.payload);
        this.log(response);

        this.generateToast("Domain Created", "success");
        this.$emit("domain-created");
        this.closeModal();
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    async updateDomain() {
      this.loading = true;
      try {
        const response = await this.$_updateDomain(
          {
            "indexPosition": 1,
            "updatedSubDomain": {
                "name": this.payload.subDomain.name,
                "email": this.payload.subDomain.email,
                "password": this.payload.subDomain.password
            }
        }
        );
        this.log(response);
        this.$emit("domain-created");
        this.closeModal();
        this.generateToast("Domain Updated!", "success");
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },

    closeModal() {
      this.subDomain = {
        name: "",
        email: "",
        password: "",
      };
      this.$emit("close-modal");
    },
    async getAllStates() {
      try {
        let response = await this.$_getAllStates();
        console.log(response);
        this.states = response.data.findState;
        this.fetchCitiesInState();
      } catch (error) {
        this.handleError(error);
      }
    },
    fetchCitiesInState() {
      if (this.subDomain.state.length) {
        let formattedStateName = this.subDomain.state
          .replace(/\s/g, "")
          .replace("State", "")
          .toLowerCase();
        this.getCities(formattedStateName);
      }
    },
    async getCities(stateName) {
      this.cities = [];
      try {
        let response = await this.$_getCities(stateName);
        this.cities = response.data.allCities;
      } catch (error) {
        this.handleError(error);
      }
    },
    setAddress(addressData) {
      this.subDomain.address.name = addressData.route;
      this.subDomain.address.lat = addressData.latitude;
      this.subDomain.address.lng = addressData.longitude;
    },
  },
};
</script>

<style scoped></style>
